import {
    useState,
    useEffect
} from 'react'
import {
    useSelector
} from 'react-redux'

import {
    Text,
    Center,
    Box,
    Button,
    Table,
    TableContainer,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    Switch,
    FormControl,
    FormLabel,
    WrapItem,
    Tooltip,
    Stack,
} from '@chakra-ui/react'
import {
    AiOutlineQuestionCircle,
} from 'react-icons/ai'
import {
    DeleteIcon,
} from '@chakra-ui/icons'

import StationSearch from './StationSearch'

export default function ViaPointSubform({ setViaPointsIds }) {

    const { journeys } = useSelector((state) => state.journeys)
    const { maps } = useSelector((state) => state.creator)

    const [allViaStations, setAllViaStations] = useState([])
    const [isShown, setIsShown] = useState(false)

    function subformSearchSetViaStation(station) {
        if (station !== undefined)
            setAllViaStations((() => [...allViaStations, station]))
    }

    function viaPointsToggleOnChange() {
        setIsShown(!isShown)

        if (!isShown)
            setAllViaStations([])
    }

    // Clearing table by detecting change in journeys or maps (creator)
    useEffect(() => {
        setAllViaStations([])
        setIsShown(false)
    }, [journeys, maps])

    useEffect(() => {
        let tempViaPointsIds = []
        allViaStations.map((station) => (tempViaPointsIds.push(station._id)))
        setViaPointsIds(tempViaPointsIds)
    }, [allViaStations])

    function viaPointDeleteOnClick(station) {
        let tempAllViaStations = allViaStations.filter((s) => station._id !== s._id)
        setAllViaStations(tempAllViaStations)
    }

    return (
        <>
            <Box
                borderWidth={isShown ? '1px' : undefined}
                md={2}
            >
                <FormControl
                    display='flex'
                    alignItems='center'
                >
                    <FormLabel>Add via points (experimental):</FormLabel>

                    <WrapItem>
                        <Tooltip
                            label='Overwrite the default route by adding intermediate stations. This feature is currently experimental and supports a maximum of 5 points.'
                            closeDelay={100}
                            isDisabled={isShown}
                        >
                            <Stack
                                direction='row'
                            >
                                <AiOutlineQuestionCircle />

                                <Switch
                                    onChange={viaPointsToggleOnChange}
                                    value={isShown}
                                    isChecked={isShown}
                                />
                            </Stack>
                        </Tooltip>
                    </WrapItem>
                </FormControl>

                {isShown && (<>
                    <Box>
                        {allViaStations.length > 0 ? (
                            <Box>
                            <TableContainer>
                                <Table
                                    variant='striped'
                                >
                                    <Thead>
                                        <Tr>
                                            <Th>Station</Th>
                                            <Th></Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {
                                            allViaStations.map((station) => (
                                                <Tr>
                                                    <Td>{station.name}</Td>
                                                    <Td>
                                                        <Button
                                                            variant='outline'
                                                            onClick={() => viaPointDeleteOnClick(station)}
                                                        >
                                                            <DeleteIcon />
                                                        </Button>
                                                    </Td>
                                                </Tr>
                                            ))
                                        }
                                    </Tbody>
                                </Table>
                            </TableContainer>
                            { allViaStations.length > 0 && (
                                <Box p={2}>
                                    <Center>
                                        <Text
                                            color='grey.500'
                                            fontSize='sm'
                                        >
                                            Add up to 5 intermediate points by searching & selecting the required stations sequentially.
                                        </Text>
                                    </Center>
                                </Box>
                            )}
                            </Box>
                        ) : (<></>)
                        }

                        <Box 
                            p={2}
                        >
                            {allViaStations.length < 5 && (
                                <StationSearch
                                    setSelectedStation={subformSearchSetViaStation}
                                    prefilledText={''}
                                    clearOnSelect={true}
                                    placeholder={'Search intermediate stations'}
                                />)
                            }
                        </Box>
                    </Box>
                </>)}
            </Box>
        </>
    )
}